<template>
  <el-form :model="user" ref="user" :rules="rules" label-width="80px" status-icon class="register">
    <el-form-item label="昵称">
      <el-input v-model="user.alias" placeholder="请输入昵称"></el-input>
    </el-form-item>
    <el-form-item label="邮箱" prop="name" style="margin-bottom: 0;">
      <el-input v-model="user.name" placeholder="请输入邮箱" class="input"
                @change="verifyName"></el-input>
      <div class="hintBox">
        <div @click="setInput(mail)" v-for="mail in emails" :key="mail">{{mail}}</div>
      </div>
      <el-button type="text" @click="getCode" :disabled="!ableGetCode">获取动态码</el-button>
    </el-form-item>
    <el-form-item label="动态码" prop="code">
      <el-input v-model="user.code" placeholder="请输入动态码" style="width:60%;"></el-input>
      <el-button type="text" v-if="timer">{{countDown}}s</el-button>
    </el-form-item>
    <el-form-item label="密码" prop="password">
      <el-input
        v-model="user.password"
        type="password"
        placeholder="请输入用户密码"
        autocomplete="off"
        show-password
      ></el-input>

    </el-form-item>
    <el-form-item label="密码确认" prop="confirmpwd">
      <el-input
        v-model="user.confirmpwd"
        type="password"
        placeholder="请输入用户密码"
        autocomplete="off"
        show-password
      ></el-input>
    </el-form-item>

    <div style="text-align: center">
      <el-button @click.prevent="register" @keyup.enter="register" type="primary" native-type="submit"
                 style="width: 150px;">注册
      </el-button>
      <el-button @click="cancel(false)" style="width: 150px;">返回</el-button>
    </div>
  </el-form>
</template>
<script>
  import {Loading} from "element-ui"

  export default {
    data() {
      let validatePass = (rule, value, callback) => {
        const reg = /^[_a-zA-Z0-9]+$/
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (!reg.test(value)) {
            callback(new Error('只允许英文字母、数字、下划线'))
          }
          if (this.user.confirmpwd !== '') {
            this.$refs.user.validateField('confirmpwd');
          }
          callback();
        }
      };
      let validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.user.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        user: {
          name: '',
          password: '',
          confirmpwd: '',
          code: '',
          alias: ''
        },
        countDown: 600, // 10分钟
        emailList:[],
        timer: null, //计时器
        rules: {
          name: [{required: true, message: '必填项'}, {type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change']}],
          password: [{required: true, message: '必填项'}, {validator: validatePass, trigger: 'blur'}],
          confirmpwd: [{required: true, message: '必填项'}, {validator: validatePass2, trigger: 'blur'}],
          code: [{required: true, message: '必填项'}]
        },
        ableGetCode: true, //是否允许获取验证码
      }
    },
    computed: {
      emails() {
        // 如果inputEmail中没有任何东西，则不处理
        if (!this.user.name) return [];
        // 手动输入@符号，如果@符号首次出现的位置大于等于第零个位置时，则不处理
        if (this.user.name.indexOf('@') > -1) return [];
        let emailArr = [];
        for (let i = 0; i < this.emailList.length; i++) {
          emailArr.push( this.user.name + this.emailList[i] ) ;
        }
        return emailArr ;
      }
    },
    created(){
      this.getEmailList()
    },
    methods: {
      setInput(mail) {
        this.user.name = mail
      },
      register() {
        this.$refs.user.validate(valid => {
          if (valid) {
            let loading = Loading.service({
              fullscreen: true,
              text: "数据加载中..."
            });
            let param = {
              name: this.user.name,
              alias: this.user.alias,
              password: window.getMD5(this.user.password),
              confirmpwd: window.getMD5(this.user.confirmpwd),
              code: this.user.code
            };
            this.$axios.post(this.baseUrl3 + 'security/register', param)
              .then(({data: {msg, data, code}}) => {
                if (code == 20000) {
                  this.$message.success('注册成功，请联系管理员开通权限');
                  this.cancel({name: this.user.name})
                } else {
                  this.$message.error(msg)
                }
                loading.close();
              })
              .catch(error => {
                loading.close();
                this.$message({
                  showClose: true,
                  message: "系统异常",
                  type: "error"
                });
                console.log(error);
              });
          }
        })
      },
      cancel(val) {
        this.$emit('registerCallback', val)
      },
      getEmailList() {
        this.$axios.get(this.baseUrl3 + 'security/mailbox/suffix/getAll')
          .then(({data: {code, msg, data}}) => {
            this.emailList=data;
          })
          .catch(error => {
            console.log(error)
          })
      },
      getCode() {
        this.ableGetCode = false;
        // 发送获取验证码请求。发送后页面开始倒计时
        if (!this.user.name) {
          this.$message.warning('请填写邮箱');
          return
        }

        this.$axios
          .get(this.baseUrl3 + "security/emailCode/" + this.user.name + '/1')
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              this.startCount();
              this.$message.success('验证码发送成功，请到邮箱中查看')
            } else {
              this.$message({showClose: true, message: msg, type: "error"});
              console.log(msg);
            }
            this.ableGetCode = true
          })
          .catch(error => {
            this.ableGetCode = true;
            this.$message({
              showClose: true,
              message: "系统异常",
              type: "error"
            });
            console.log(error);
          });
      },
      // 计时开始
      startCount() {
        this.countDown = 600;
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null
        }
        this.timer = setInterval(() => {
          if (this.countDown == 0) {
            clearInterval(this.timer);
            this.timer = null
          } else {
            this.countDown--
          }
        }, 1000)
      },
      verifyName(name) {
        if (!name) {
          return
        }
        this.$axios.get(this.baseUrl3 + 'security/verifyName/' + name)
          .then(({data: {msg, data, code}}) => {
            if (data) {
              this.$message.warning('该账户已存在，请直接登录');
              this.cancel({name: name})
            }
          })
          .catch(error => {
            this.$message({
              showClose: true,
              message: "系统异常",
              type: "error"
            });
            console.log(error);
          });
      },
    }
  }
</script>
<style scoped>
  /* .register >>> .el-input{
      width: 60%;
  } */
  .hintBox {
    width: 100%;
    max-height: 120px;
    overflow-y: scroll;
    overflow-x: auto;
    position: absolute;
    z-index: 999;
    background-color: #fff;
  }
</style>
